const PDP_VIEW_INTERACTION_LOCATION_KEY = 'pdp_view_interaction_location';

export const getPdpViewInteractionLocation = () => {
  if (typeof window === 'undefined') return undefined;

  try {
    return window.sessionStorage.getItem(PDP_VIEW_INTERACTION_LOCATION_KEY) || undefined;
  } catch {
    return undefined;
  }
};

export const setPdpViewInteractionLocation = (interactionLocation: string) => {
  if (typeof window === 'undefined') return;

  try {
    window.sessionStorage.setItem(PDP_VIEW_INTERACTION_LOCATION_KEY, interactionLocation);
  } catch {
    // Session storage can be unavailable in restricted browsing contexts.
  }
};

export const consumePdpViewInteractionLocation = () => {
  if (typeof window === 'undefined') return undefined;

  try {
    const interactionLocation = window.sessionStorage.getItem(PDP_VIEW_INTERACTION_LOCATION_KEY);
    window.sessionStorage.removeItem(PDP_VIEW_INTERACTION_LOCATION_KEY);
    return interactionLocation || undefined;
  } catch {
    return undefined;
  }
};
